export const CONFIGEXCEL_SET_LIST_DATA = 'CONFIGEXCEL_SET_LIST_DATA';
export const CONFIGEXCEL_SET_LIST_META = 'CONFIGEXCEL_SET_LIST_META';
export const CONFIGEXCEL_TITLE = 'Cấu hình Excel';